import axios from 'axios'
// const API_URL = 'http://localhost/lsm-api/'
// const APP_URL = 'http://localhost:8080/'

// const API_URL = 'https://lsm.intowin.es/api/';
// const APP_URL = 'https://lsm.intowin.es/';

const API_URL = process.env.VUE_APP_API_URL

const APP_URL = process.env.VUE_APP_BASE_URL

// const API_URL = 'https://lsm.mcdonalds.es/beta/api/index.php/'
// const APP_URL = 'https://lsm.mcdonalds.es/beta/'

// const API_URL = 'http://ec2-54-194-101-148.eu-west-1.compute.amazonaws.com/api/';
// const APP_URL = 'http://ec2-54-194-101-148.eu-west-1.compute.amazonaws.com/';

export class Api {
  constructor () {}

  login (params) {
    const url = API_URL + 'login'
    var self = this
    const oParams = new URLSearchParams()
    Object.keys(params).forEach(key => {
      oParams.append(key, params[key])
    })

    /* return axios({
			method: 'post',
			url: url+ '?nocache=' + new Date().getTime(),
			withCredentials: true,
			data: oParams
		}).then(response => {
			console.log( response );
			if( response.status == 200 )
				return response.data;
		}); */

    return axios
      .post(url + '?nocache=' + new Date().getTime(), oParams, {
        withCredentials: true
      })
      .then(function (response) {
        console.log(response)
        if (response.status == 200) return response.data
      })
  }

  getSession () {
    const url = API_URL + 'init'
    var self = this
    return axios
      .get(url, {
        withCredentials: true,
        validateStatus: function (status) {
          if (status == 403) {
            return {
              status: false,
              error: 403
            }
          }
          return true
        }
      })
      .then(function (response) {
        return response.data
      })
  }

  get (uri) {
    const url = API_URL + uri
    var self = this
    return axios
      .get(url, {
        withCredentials: true,
        validateStatus: function (status) {
          if (status == 403) {
            // window.location.reload()
          }
          return true
        }
      })
      .then(function (response) {
        return response.data
      })
  }

  post (uri, params) {
    const oParams = new URLSearchParams()
    Object.keys(params).forEach(key => {
      oParams.append(key, params[key])
    })

    const url = API_URL + uri
    return axios
      .post(url, oParams, {
        withCredentials: true,
        validateStatus: function (status) {
          if (status == 403) {
            window.location.reload()
          }
          return true
        }
      })
      .then(function (response) {
        return response.data
      })
  }

  upload (uri, params) {
    console.log(params)

    const oParams = new URLSearchParams()
    Object.keys(params).forEach(key => {
      oParams.append(key, params[key])
    })

    const url = API_URL + uri
    return axios
      .post(url, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true,
        validateStatus: function (status) {
          if (status == 403) {
            window.location.reload()
          }
          return true
        }
      })
      .then(function (response) {
        return response.data
      })
  }

  externalLoginAdmin(accountId) {
    const url = API_URL + 'login/admin/externaluser/' + accountId
    return axios
      .get(url, {
        withCredentials: true,
        validateStatus: function (status) {
          if (status == 403) {
            window.location.reload()
          }
          return true
        }
      })
      .then(function (response) {
        return response.data
      })
  }
  externalLogout() {
    const url = API_URL + 'login/admin/logout'
    return axios
      .get(url, {
        withCredentials: true,
        validateStatus: function (status) {
          if (status == 403) {
            window.location.reload()
          }
          return true
        }
      })
      .then(function (response) {
        return response.data
      })
  }
}
